<template>
  <form class="login-form" novalidate @submit.prevent="emit('submit')">
    <DsTextSplit
      as="bebas4"
      base="Bienvenido"
      highlight="de nuevo"
      base-color="var(--ds-purple-400)"
      highlight-color="var(--ds-purple-900)"
      class="login-form__title"
    />

    <DsInputField
      :model-value="correo"
      label="Correo electrónico"
      type="email"
      autocomplete="email"
      :icon-left="mailIcon"
      :error="errorCorreo"
      :invalid="correoInvalido"
      @update:model-value="emit('update:correo', $event)"
    />

    <div class="login-form__password">
      <DsInputField
        :model-value="password"
        label="Contraseña"
        :type="passwordVisible ? 'text' : 'password'"
        autocomplete="current-password"
        :error="errorPassword"
        @update:model-value="emit('update:password', $event)"
      >
        <template #suffix>
          <button
            type="button"
            class="login-form__toggle"
            :aria-label="passwordVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            @click="passwordVisible = !passwordVisible"
          >
            <img :src="passwordVisible ? eyeOffIcon : eyeIcon" alt="" aria-hidden="true">
          </button>
        </template>
      </DsInputField>

      <router-link
        :to="{ name: 'cliente-cliente-usuario-recuperacion' }"
        class="login-form__link"
      >
        ¿Olvidaste la contraseña?
      </router-link>
    </div>

    <div class="login-form__actions">
      <DsButton label="Entrar" type="submit" class="login-form__submit" />

      <DsText as="subtitle7" class="login-form__hint">¿No tienes cuenta?</DsText>

      <DsButton
        label="Registrate"
        variant="outlined"
        class="login-form__submit"
        @click="irARegistro"
      />
    </div>
  </form>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import mailIcon from '../../assets/login/ic_mail.svg'
import eyeIcon from '../../assets/login/ic_eye.svg'
import eyeOffIcon from '../../assets/login/ic_eye_off.svg'
import DsButton from '../MaterialApoyo/atoms/DsButton.vue'
import DsInputField from '../MaterialApoyo/atoms/DsInputField.vue'
import DsText from '../MaterialApoyo/atoms/DsText.vue'
import DsTextSplit from '../MaterialApoyo/atoms/DsTextSplit.vue'

defineProps<{
  correo: string
  password: string
  errorCorreo?: string
  errorPassword?: string
  correoInvalido?: boolean
}>()

const emit = defineEmits<{
  (e: 'submit'): void
  (e: 'update:correo', value: string): void
  (e: 'update:password', value: string): void
}>()

const router = useRouter()
const passwordVisible = ref(false)

function irARegistro() {
  router.push({ name: 'cliente-cliente-usuario-crear' })
}
</script>

<style scoped>
.login-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.login-form__title {
  line-height: normal;
}

.login-form__password {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.login-form__toggle {
  display: flex;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.login-form__toggle img {
  width: 18px;
  height: 18px;
  display: block;
}

.login-form__link {
  align-self: flex-end;
  padding: 10px 16px;
  color: var(--ds-purple-main);
  font-family: var(--ds-font-family-base);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-decoration: underline;
}

.login-form__actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.login-form__hint {
  color: #4e525a;
}

.login-form__submit {
  width: 100%;
}
</style>
